
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"xmlns":"http://www.w3.org/2000/svg","viewBox":"0 0 90 90","width":"90","height":"90"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"d":"M45 9a35.9 35.9 0 00-23.379 8.625 3.001 3.001 0 00.902 5.188 2.987 2.987 0 002.993-.63A29.848 29.848 0 0145 15c15.59 0 28.352 11.813 29.852 27H66l12 18 12-18h-9.152C79.313 23.555 63.832 9 45 9zM12 30L0 48h9.152C10.688 66.445 26.168 81 45 81a35.9 35.9 0 0023.379-8.625 3.001 3.001 0 00-.902-5.188 2.987 2.987 0 00-2.993.63A29.848 29.848 0 0145 75c-15.59 0-28.352-11.813-29.855-27H24zm0 0","fill":"#fff"}})])
          )
        }
      }
    